<ng-container *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'">
  <p-table [value]="masterOperations | showByValidCondition : validConditionFilter : showPhantoms : null : processSelectors"
           styleClass="p-datatable-xs integrated-master-editor w-100 p-datatable-gridlines no-border-form-controls sticky-header sticky-header-below-actionbar pb-2"
           [autoLayout]="false" [rowGroupMode]="'subheader'" [groupRowsBy]="'RowGroupKey'" dataKey="ProcessSelectorId" [expandedRowKeys]="expandedRowKeys">
    <ng-template pTemplate="header">
      <tr>
        <th class="w-4"><span>{{t('Nr')}}</span></th>
        <th class="min-wx-128"><span>{{t('Process')}}</span></th>
        <th class="min-wx-128" *ngIf="settings.Visibility.ProcessValidExpressions"><span>{{t('Process Valid')}}</span>
        </th>
        <th class="min-wx-160"><span>{{t('Operation Specs')}}</span></th>
        <th class="" *ngIf="settings.Visibility.TaskSelector"><span>{{t('TS')}}</span></th>
        <th class=""><span>{{t('Instruction Code')}}</span></th>
        <th class="min-wx-256">
          <div class="d-flex flex-wrap">
            <span class="bl-3 border-primary ms-1 mb-1 ps-1" *ngIf="allowItemGroupsAsInputs || allowItemGroupsAsOutputs || !isManufacturingItem">{{t('Item Group')}}</span>
            <span class="bl-3 border-secondary ms-1 mb-1 ps-1">{{t('Item')}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <span class="bl-3 border-left-green-600 ms-1 mb-1 ps-1" *ngIf="allowResourceTemplate">{{t('Resource Template')}}</span>
            <span class="bl-3 border-info ms-1 mb-1 ps-1">{{t('Resource')}}</span>
          </div>
        </th>
        <th class="w-4"><span>{{t('Prev Nr')}}</span></th>
        <th class="" *ngIf="settings.Visibility.Setup"><span>{{t('Setup')}}</span></th>
        <th class=""><span>{{t('Production')}}</span></th>
        <th class="" *ngIf="settings.Visibility.Teardown"><span>{{t('Teardown')}}</span></th>
        <th class="min-wx-256" *ngIf="settings.Visibility.ValidExpressions"><span>{{t('Valid Condition')}}</span></th>
        <th class="w-4" *ngIf="settings.Visibility.ValidFromToDates"><span>{{t('Valid From/To')}}</span></th>
        <th class="min-wx-160"><span>{{t('Instruction Specs')}}</span></th>
        <th class="" *ngIf="settings.Visibility.OperationSplitSizeMax"><span>{{t('Operation Split Size Max')}}</span></th>
        <th class="w-4"><span>{{t('Yield rate')}}</span></th>
        <ng-container *ngIf="settings.Visibility.TimeConstraints">
          <th class="min-wx-56" title="Time constraint method"><span>{{t('TC')}}</span></th>
          <th class="min-wx-56" title="Time constraint min"><span>{{t('TC-Min')}}</span></th>
          <th class="min-wx-56" title="Time constraint max"><span>{{t('TC-Max')}}</span></th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="groupheader" let-op let-expanded="expanded">
      <tr pRowGroupHeader *ngIf="processSelectors | find: 'Id': op.ProcessSelectorId as ps" class="bg-gray-100">
        <td class="border-end-0">
          <a href="javascript:void(0)" class="fs-5 my-auto pi" [class.pi-chevron-right]="!expanded" [class.pi-chevron-down]="expanded" title="Expand/Collapse Row" [pRowToggler]="op"> </a>
        </td>
        <ng-container *ngIf="ps?.Id; else noPs">
          <td colspan="2" class="border-x-0">
            <ul class="list-unstyled">
              <li>{{t('Process Selector')}}:</li>
              <li>
                <h5>{{ps?.Code}}</h5>
                <app-source-code-view [code]="ps?.Code" [sourceCode]="ps?.SourceCode"></app-source-code-view>
              </li>
            </ul>
          </td>
          <td [attr.colspan]="nrOfColumns - 6" class="border-x-0">
            <ul class="list-inline" *ngIf="ps.Specs?.length > 0">
              <li class="list-inline-item" *ngIf="ps.Sequence"><em>{{t('Sequence')}}</em>: {{ps.Sequence}}</li>
              <app-spec-lines-view [specs]="ps.Specs"></app-spec-lines-view>
            </ul>
            <app-expression-formula-view [expression]="ps.ValidCondition"></app-expression-formula-view>
          </td>
          <td colspan="3" class="border-start-0 text-end">
            <div class="my-auto">
              <div class="btn-group me-1">
                <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="showProcessSelectorEditModal(ps, 'edit')">{{t('Edit')}}</button>
                <div class="btn-group btn-group-sm" ngbDropdown role="group" [container]="'body'" #psDropdown="ngbDropdown" [autoClose]="'outside'">
                  <button type="button" class="btn btn-outline-primary dropdown-toggle-split" ngbDropdownToggle></button>
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <ng-container *ngIf="!readonly">
                      <button type="button" ngbDropdownItem (click)="addProcess(ps); psDropdown.close()">{{t('Add process')}}</button>
                      <button type="button" ngbDropdownItem (click)="addNewProcessSelector(); psDropdown.close()">{{t('Add Process selector')}}</button>
                      <div ngbDropdown class="dropdown-item">
                        <button type="button" class="btn p-0" ngbDropdownToggle>{{t('Delete')}}</button>
                        <div ngbDropdownMenu>
                          <h6 class="dropdown-header">{{t('Delete')}} {{ps.Code}}</h6>
                          <button type="button" ngbDropdownItem class="text-danger" (click)="removeProcessSelector('deleteWithOperations', ps.Id)">{{t('With processes')}}</button>
                          <button type="button" ngbDropdownItem class="text-danger" (click)="removeProcessSelector('delete', ps.Id)" *ngIf="processSelectors.length < 2">{{t('Keep processes')}}</button>
                          <ng-container *ngIf="processSelectors.length > 1">
                            <h6 class="dropdown-header">{{t('Delete all process selectors')}}</h6>
                            <button type="button" ngbDropdownItem class="text-danger" (click)="removeAllProcessSelectors('deleteWithOperations')">{{t('With processes')}}</button>
                            <button type="button" ngbDropdownItem class="text-danger" (click)="removeAllProcessSelectors('delete')">{{t('Keep processes')}}</button>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                    <app-copy-paste-menu-item [allowCopyAll]="processSelectors.length > 1" [readonly]="readonly"
                                              (onCopy)="copyProcessSelector(ps); psDropdown.close()"
                                              (onCopyAll)="copyProcessSelector(ps, true); psDropdown.close()"
                                              (onPaste)="paste('ProcessSelector', null, ps); psDropdown.close()"
                                              (onClipboardPaste)="paste('ProcessSelector', null, ps, true); psDropdown.close()"></app-copy-paste-menu-item>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-template #noPs>
          <td [attr.colspan]="nrOfColumns - 1" class="border-left-0 text-end"></td>
        </ng-template>
      </tr>
    </ng-template>
    <ng-template [pTemplate]="bodyTemplateName" let-line>
      <ng-container *ngLet="asMasterOperation(line) as mo">
        <ng-container *ngLet="processSelectors | find: 'Id': mo.ProcessSelectorId as ps">
          <tr *ngLet="mo['RowCount'] ?? getCountOfRowsToShow(mo) as rowSpan">
            <td class="cell-action-container process align-top" [attr.rowspan]="rowSpan" pEditableColumn>
              <p-cellEditor mesStopDragPropagation>
                <ng-template pTemplate="input">
                  <input name="processNumber-{{mo.Id}}" class="form-control content-editable border-0" type="number" [(ngModel)]="mo.ProcessNumber" [disabled]="readonly" (ngModelChange)="setChanged()" mesStopArrowKeyPropagation/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{mo.ProcessNumber}}
                </ng-template>
              </p-cellEditor>
              <app-source-code-view [code]="mo.Code" [sourceCode]="mo.SourceCode"></app-source-code-view>
              <div class="cell-action top right" ngbDropdown container="body" #processDropdownTop="ngbDropdown" [autoClose]="'outside'" *ngIf="mo.TaskSelectors.length > 5 || mo.MasterInputInstructions.length > 5">
                <button class="btn btn-outline-default btn-sm dropdown-toggle" tabindex="-1" type="button" ngbDropdownToggle (click)="$event.stopPropagation()">±</button>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <ng-container *ngTemplateOutlet="processDropdownTemplate; context: {dropdown: processDropdownTop}"></ng-container>
                </div>
              </div>
              <div class="cell-action" ngbDropdown container="body" #processDropdown="ngbDropdown" [autoClose]="'outside'">
                <button class="btn btn-outline-default btn-sm dropdown-toggle" tabindex="-1" type="button" ngbDropdownToggle (click)="$event.stopPropagation()">±</button>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <ng-container *ngTemplateOutlet="processDropdownTemplate; context: {dropdown: processDropdown}"></ng-container>
                </div>
              </div>
              <ng-template #processDropdownTemplate let-processDropdown="dropdown">
                <ng-container *ngIf="!readonly">
                  <a class="dropdown-item" (click)="addProcessAfter(mo); processDropdown.close()">{{t('Add process')}}</a>
                  <a class="dropdown-item" (click)="integratedMasterService.addMasterUseInstructionAfter(mo, mo.getLastUseInstruction()); setChanged(); processDropdown.close()">{{t('Add resource usage')}}</a>
                  <a class="dropdown-item" (click)="integratedMasterService.addMasterInputInstructionAfter(mo, mo.getLastInputInstruction()); setChanged(); processDropdown.close()">{{t('Add item usage')}}</a>
                  <a class="dropdown-item" (click)="integratedMasterService.addMasterOutputInstructionAfter(mo, mo.getLastOutputInstruction()); setChanged(); processDropdown.close()">{{t('Add process result')}}</a>
                  <a class="dropdown-item with-icon" (click)="editOperationItemProperties(mo); processDropdown.close()"><i class="fa fa-random"></i><span>{{t('Specs')}}</span></a>
                  <div class="d-flex dropdown-item flex-wrap">
                    <label class="col-form-label col-12 me-2 pt-0">{{t('Source Code')}}</label>
                    <div class="col-12">
                      <input type="text" class="form-control" id="SourceCode-{{mo.Id}}" name="SourceCode-{{mo.Id}}" [(ngModel)]="mo.SourceCode">
                    </div>
                  </div>
                  <div ngbDropdown class="dropdown-item">
                    <button type="button" class="btn btn-link p-0" ngbDropdownToggle>{{t('Process selector')}}: {{ps?.Code}}</button>
                    <div ngbDropdownMenu>
                      <button type="button" ngbDropdownItem (click)="addNewProcessSelector(); processDropdown.close()">{{t('Add Process selector')}}</button>
                      <button type="button" ngbDropdownItem *ngFor="let ps1 of processSelectors | where: 'Id': undefined: null: true; trackBy: trackById" (click)="changeProcessSelector(mo, ps1); processDropdown.close()">{{ps1.Code}}</button>
                    </div>
                  </div>
                  <div ngbDropdown class="dropdown-item">
                    <button type="button" class="btn p-0" ngbDropdownToggle (click)="validConditionFilter = null">{{t('Delete')}}</button>
                    <div ngbDropdownMenu>
                      <button type="button" ngbDropdownItem class="text-danger" (click)="removeProcess(mo)">{{t('Delete process')}} {{mo.ProcessNumber}}</button>
                      <ng-container *ngLet="(masterOperations | where : 'ProcessSelectorId' : mo.ProcessSelectorId : true) as mosInPs">
                        <button type="button" ngbDropdownItem class="text-danger" (click)="removeProcesses(mosInPs)" *ngIf="mosInPs.length > 1">
                          {{t('Delete processes')}} <span *ngFor="let moInPs of mosInPs; let last = last; trackBy: trackById">{{moInPs.ProcessNumber}}<ng-container *ngIf="!last">, </ng-container></span>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <a *ngIf="isManufacturingItem" class="dropdown-item" [ngClass]="{'active': validConditionFilter}" (click)="validConditionFilter = validConditionFilter ? null : 'True'; processDropdown.close()">
                  {{t('Show only valid')}}
                </a>
                <a class="dropdown-item" [ngClass]="{'active': showPhantoms}" (click)="showPhantoms = !showPhantoms; processDropdown.close()">
                  {{t('Show phantoms')}}
                </a>
                <ng-container *ngIf="masterOperations | where: 'ProcessSelectorId': mo.ProcessSelectorId as mos">
                  <app-copy-paste-menu-item [allowCopyAll]="mos.length > 1" [readonly]="readonly"
                                            (onCopy)="copyPasteService.copy('MasterOperation', [mo]); processDropdown.close()"
                                            (onCopyAll)="copyPasteService.copy('MasterOperation', mos); processDropdown.close()"
                                            (onPaste)="paste('MasterOperation', mo, ps); processDropdown.close()"
                                            (onClipboardPaste)="paste('MasterOperation', mo, ps, true); processDropdown.close()"></app-copy-paste-menu-item>
                </ng-container>
              </ng-template>
            </td>
            <td pEditableColumn class="process align-top text-break" [attr.rowspan]="rowSpan" id="operationId-{{mo.Id}}" mesStopClickPropagation>
              <p-cellEditor mesStopDragPropagation>
                <ng-template pTemplate="input">
                  <ng-container *ngIf="readonly; else selectProcess">
                    <a href="javascript:void(0)" (click)="openProcessEditModal(mo.ProcessId)">
                      {{processService.query.selectEntity(mo.ProcessId) | async | displayName}}
                    </a>
                  </ng-container>
                  <ng-template #selectProcess>
                    <mes-web-process-select [items$]="processService.getAll$" [initOpened]="true" [readonly]="readonly" name="processId-{{mo.Id}}" [(entityId)]="mo.ProcessId"></mes-web-process-select>
                  </ng-template>
                </ng-template>
                <ng-template pTemplate="output">
                  {{processService.query.selectEntity(mo.ProcessId) | async | displayName}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td app-expression-formula-cell class="cell-action-container process align-top" *ngIf="settings.Visibility.ProcessValidExpressions"
                [attr.rowspan]="rowSpan" [ngbTooltip]="mo.ParentValidCondition" container="body" mesStopClickPropagation
                [expression]="mo.ValidCondition" [readonly]="readonly" (changed)="setChanged(); mo.ValidCondition = $event">
            </td>
            <td class="cell-action-container process align-top text-break" [attr.rowspan]="rowSpan">
              <app-ime-spec-lines-view [specs]="mo.Specs" [masterOperation]="mo" [readonly]="readonly" (changed)="mo.Specs = $event; setChanged()" [context]="mo"></app-ime-spec-lines-view>
            </td>
            <td [attr.colspan]="nrOfColumns - 4" class="process empty"></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="settings.Visibility.TaskSelector; else noTaskSelectors">
          <ng-container [ngTemplateOutlet]="noTaskSelectors"></ng-container>
          <ng-container *ngFor="let ts of mo.TaskSelectors | orderBy: ['Sequence','Code']; let index = index; trackBy: trackById">
            <ng-container *ngLet="mo.MasterInputInstructions | union: [mo.MasterUseInstructions] | union: [mo.MasterOutputInstructions] | filterBy: ['TaskSelectorId']: ts.Id | showByValidCondition : validConditionFilter : showPhantoms : mo as instructions">
              <tr class="mes-conf group" *ngIf="instructions.length === 0">
                <td class="mes-conf group">
                  <ime-task-selector-cell [taskSelector]="ts" [masterOperation]="mo" [readonly]="readonly" (changed)="setChanged()"></ime-task-selector-cell>
                </td>
              </tr>
              <ng-container *ngFor="let instruction of instructions; let isFirst = first; let odd = odd; let ix = index; trackBy: trackById">
                <tr mes-master-input-instruction-edit *ngIf="instruction.Type === InstructionType.Input"
                    [ngClass]="{'odd' : odd}" [masterOperation]="mo"
                    [taskSelector]="ts" [index]="ix" [nrOfInstructionsInTaskSelector]="instructions.length"
                    [masterInputInstruction]="instruction" [settings]="settings.Visibility" [readonly]="readonly"
                    [isManufacturingItem]="isManufacturingItem"
                    [isAlternative]="instruction | isAlternative: mo.MasterInputInstructions"
                    [allowItemGroupsAsInputs]="allowItemGroupsAsInputs"
                    (onShowIme)="showIme($event)" (changed)="setChanged()">
                </tr>
                <tr mes-master-use-instruction-edit *ngIf="instruction.Type === InstructionType.Use"
                    [ngClass]="{'odd' : odd}" [masterOperation]="mo"
                    [taskSelector]="ts" [index]="ix" [nrOfInstructionsInTaskSelector]="instructions.length"
                    [masterUseInstruction]="instruction" [settings]="settings.Visibility" [readonly]="readonly"
                    [isAlternative]="instruction | isAlternative: mo.MasterUseInstructions"
                    [allowResourceTemplate]="allowResourceTemplate"
                    (changed)="setChanged()">
                </tr>
                <tr mes-master-output-instruction-edit *ngIf="instruction.Type === InstructionType.Output"
                    [ngClass]="{'odd' : odd}" [masterOperation]="mo"
                    [taskSelector]="ts" [index]="ix" [nrOfInstructionsInTaskSelector]="instructions.length"
                    [masterOutputInstruction]="instruction" [settings]="settings.Visibility" [readonly]="readonly"
                    [isAlternative]="instruction | isAlternative: mo.MasterOutputInstructions"
                    [allowItemGroupsAsOutputs]="allowItemGroupsAsOutputs"
                    (changed)="setChanged()">
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #noTaskSelectors>
          <ng-container *ngFor="let mii of mo.MasterInputInstructions | showByValidCondition : validConditionFilter : showPhantoms : mo; let odd = odd; trackBy: trackById">
            <tr *ngIf="!mii.TaskSelectorId || !settings.Visibility.TaskSelector" class="materials" mes-master-input-instruction-edit
                [ngClass]="{'odd' : odd}" [masterOperation]="mo" [masterInputInstruction]="mii" [settings]="settings.Visibility" [readonly]="readonly"
                [isAlternative]="mii | isAlternative: mo.MasterInputInstructions"
                [isManufacturingItem]="isManufacturingItem"
                (onShowIme)="showIme($event)"
                (changed)="setChanged()"
                [allowItemGroupsAsInputs]="allowItemGroupsAsInputs">
            </tr>
          </ng-container>
          <ng-container *ngFor="let mui of mo.MasterUseInstructions | showByValidCondition : validConditionFilter : showPhantoms : mo; let odd = odd; trackBy: trackById">
            <tr *ngIf="!mui.TaskSelectorId || !settings.Visibility.TaskSelector" class="people" mes-master-use-instruction-edit
                [ngClass]="{'odd' : odd}"
                [masterOperation]="mo"
                [masterUseInstruction]="mui"
                [settings]="settings.Visibility"
                [readonly]="readonly"
                [isAlternative]="mui | isAlternative: mo.MasterUseInstructions"
                [allowResourceTemplate]="allowResourceTemplate"
                (changed)="setChanged()">
            </tr>
          </ng-container>
          <ng-container *ngFor="let moi of mo.MasterOutputInstructions | showByValidCondition : validConditionFilter : showPhantoms : mo | orderBy: 'Sequence' | orderBy: 'Code'; let odd = odd; trackBy: trackById">
            <tr *ngIf="!moi.TaskSelectorId || !settings.Visibility.TaskSelector" class="materials" mes-master-output-instruction-edit
                [ngClass]="{'odd' : odd}" [masterOperation]="mo" [masterOutputInstruction]="moi" [settings]="settings.Visibility" [readonly]="readonly"
                [isAlternative]="moi | isAlternative: mo.MasterOutputInstructions"
                (changed)="setChanged()"
                [allowItemGroupsAsOutputs]="allowItemGroupsAsOutputs">
            </tr>
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-template>
  </p-table>
  <ng-container *ngIf="!masterOperations?.length && !readonly">
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="ensureAnyProcess()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      {{t('Add process')}}
    </button>
    <button type="button" class="btn btn-sm btn-outline-primary ms-1" (click)="ensureAnyProcess(); addNewProcessSelector()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      {{t('Add process selector')}}
    </button>
    <div class="btn-group" ngbDropdown>
      <button type="button" class="dropdown-toggle btn btn-sm btn-outline-primary ms-1" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Paste')}}
      </button>
      <div class="dropdown-menu dropdown-menu-sm dropdown-menu-end" ngbDropdownMenu>
        <button type="button" ngbDropdownItem (click)="paste('MasterOperation', null, null)">{{t('Paste')}}</button>
        <button type="button" ngbDropdownItem (click)="paste('MasterOperation', null, null, true)">{{t('Paste from clipboard')}}</button>
      </div>
    </div>
  </ng-container>
</ng-container>
